import { UserModel } from '../../api/api.models'
import { CommonHelper } from '../../../helpers/common-helper'
import { IUserSession } from '../../../helpers/user-session'
import { OpOperator } from '../../../models/core/op-operator';

var USER: any
var i18nUserSession: IUserSession

var translate = (collection: string, word: string) => {
    if (!USER) {
        USER = CommonHelper.getValueFromLocalStorage('USER')
    }

    let idDistributor: number = undefined
    let idProfileConfigurationCode: number = undefined

    if (i18nUserSession)
    {
        const loggedOper: OpOperator = i18nUserSession.getDataProvider().Operator.getLoggedOperatorLocal()
        if (loggedOper && loggedOper.profile) {
            idProfileConfigurationCode = loggedOper.profile.configurationCode
        }
    }

    var user: UserModel = USER

    if (user) {
        idDistributor = user.idDistributor
    }

    const distributorKeyPrefix: string = 'Distributor'
    const profileConfigurationCodeKeyPrefix: string = 'ProfileConfigurationCode'

    const resource: any = global['resource']

    if (word != null) {
        const key: string = word.toLowerCase()

        const distributorCollectionKey: string = idDistributor ? (distributorKeyPrefix + idDistributor) : undefined
        const profileCollectionKey: string = idProfileConfigurationCode ? (profileConfigurationCodeKeyPrefix + idProfileConfigurationCode) : undefined

        if (resource) {
            if (distributorCollectionKey && resource[distributorCollectionKey] && resource[distributorCollectionKey][key]) {
                return resource[distributorCollectionKey][key]
            }

            if (profileCollectionKey && resource[profileCollectionKey] && resource[profileCollectionKey][key]) {
                return resource[profileCollectionKey][key]
            }

            if(resource[collection] && resource[collection][key]) {
                return resource[collection][key]
            }
        }
    }

    return word
}

var userSessionSetter = (userSession: IUserSession) => {
    i18nUserSession = userSession;
}

export var i18n = translate
export var setUserSession = userSessionSetter